var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"icon-img",attrs:{"src":_vm.getAttachUrl(_vm.imgInfo)}})
}
var staticRenderFns = []

export { render, staticRenderFns }